var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "44px",
    viewBox: "0 0 32 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fill: "#FF0064",
    points: "0 44 0 0 32 0 32 44 16.5 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-64",
    fill: "#00FFC2",
    points: "15.99249 27.00752 10.99249 22.00752 5.99249 27.00752 10.99249 32.00752"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-66",
    fill: "#00FFC2",
    points: "26.00752 27.00752 21.00752 22.00752 16.00752 27.00752 21.00752 32.00752"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-68",
    fill: "#00FFC2",
    points: "15.99249 16.99249 10.99249 11.99249 5.99249 16.99249 10.99249 21.99249"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-70",
    fill: "#00FFC2",
    points: "26.00752 16.99249 21.00752 11.99249 16.00752 16.99249 21.00752 21.99249"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-72",
    fill: "#00FFC2",
    points: "20.99811 35.29689 15.99811 30.29689 10.99811 35.29689 15.99811 40.29689"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-74",
    fill: "#00FFC2",
    points: "20.99811 8.70311 15.99811 3.70311 10.99811 8.70311 15.99811 13.70311"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.077ab8f092b50cf7eff3899ce217b5f4.svg";
export { ForwardRef as ReactComponent };